import React, { useEffect } from 'react';
import { Container, Grid } from '@mui/material';
import { useNavigate,useLocation } from 'react-router-dom';
import CalculatorCard from './calculator';
import ReactGA from 'react-ga4';
import { title } from 'process';
const Dashboard: React.FC = () => {
  const navigate = useNavigate();
  const location = useLocation();
  
  useEffect(() => {
    ReactGA.initialize('G-ZBDG6JK7J4'); 
    ReactGA.send({ hitType: 'pageview', page: location.pathname , title:"Dashboard"}); },
     [location]);

   const handleInterestClick = () => {
    ReactGA.event({
      category: "Calculator",
      action: "Clicked on Interest Calculator",
      label: "Interest Calculator"
    });
    navigate('/interestCalculator.html');
  };


  const handleEMIClick = () => {
    ReactGA.event({
      category: "Calculator",
      action: "Clicked on EMI Calculator",
      label: "EMI Calculator"
    });
    navigate('/emi-calculator.html');
  };

  const handleFDCClick = () => {
    ReactGA.event({
      category: "Calculator",
      action: "Clicked on FD Calculator",
      label: "FD Calculator"
    });
    navigate('/fixed-deposit-calculator.html');
  };

  const handleSIPClick = () => {
    ReactGA.event({
      category: "Calculator",
      action: "Clicked on SIP Calculator",
      label: "SIP Calculator"
    });
    navigate('/sip-calculator.html');
  };

  const handleSWPClick = () => {
    ReactGA.event({
      category: "Calculator",
      action: "Clicked on SWP Calculator",
      label: "SWP Calculator"
    });
    navigate('/swp-calculator.html');
  };

  const handleLumpSumCalculatorClick = () => {
    ReactGA.event({
      category: "Calculator",
      action: "Clicked on Lumpsum Calculator",
      label: "Lumpsum Calculator"
    });
    navigate('/lumpsum-calculator.html');
  };
  const handleRDClick = () => {
    ReactGA.event({
      category: "Calculator",
      action: "Clicked on RD Calculator",
      label: "RD Calculator"
    });
    navigate('/recurring-deposit.html');
  };

  const handleStepUpSIPCalculatorClick = () => {
    ReactGA.event({
      category: "Calculator",
      action: "Clicked on Stepup SIP Calculator",
      label: "StepUp SIP Calculator"
    });
    navigate('/stepup-sip-calculator.html');
  };
  const handleGoalSIPCalculatorClick = () => {
    ReactGA.event({
      category: "Calculator",
      action: "Clicked on Goal SIP Calculator",
      label: "Goal SIP Calculator"
    });
    navigate('/goal-sip-calculator.html');
  };

  const handleLoanComparisonCalculatorClick = () => {
    ReactGA.event({
      category: "Calculator",
      action: "Clicked on Loan Comparision Calculator",
      label: "Loan Comparision Calculator"
    });
    navigate('/loan-comparision-calculator.html');
  };

  return (
    <Container style={{ marginTop: '50px', marginBottom:'30px' }}>
      <Grid container spacing={3}>
        {/* Interest Calculator Card */}
        <Grid item xs={12} md={4}>
          <CalculatorCard 
            title="Interest"
            description="Calculate the simple interest on a principal amount over a fixed period of time. Useful for personal loans or short-term investments."
            onClick={handleInterestClick}
          />
        </Grid>

        {/* EMI Calculator Card */}
        <Grid item xs={12} md={4}>
          <CalculatorCard 
            title="EMI "
            description="Compute your Equated Monthly Installments (EMI) for any loan. Enter your loan amount, interest rate, and tenure to get your monthly payments."
            onClick={handleEMIClick}
          />
        </Grid>

        {/* Recurring Deposit Calculator Card */}
        <Grid item xs={12} md={4}>
          <CalculatorCard 
            title="Recurring Deposit "
            description="Estimate the maturity amount for recurring deposits. Ideal for regular savers who want to grow their savings over time with fixed monthly contributions."
            onClick= {handleRDClick}
          />
        </Grid>

        {/* Fixed Deposit Calculator Card */}
        <Grid item xs={12} md={4}>
          <CalculatorCard 
            title="Fixed Deposit "
            description="Calculate the final maturity value for your fixed deposits based on the principal, interest rate, and time period."
            onClick={handleFDCClick}
          />
        </Grid>

        {/* Systematic Investment Plan Card */}
        <Grid item xs={12} md={4}>
          <CalculatorCard 
            title="Systematic Investment Plan"
            description="A Systematic Investment Plan (SIP) allows you to invest a fixed amount regularly in mutual funds, promoting disciplined saving."
            onClick={handleSIPClick}
          />
        </Grid>

        {/* Systematic Withdrawal Plan Card */}
        <Grid item xs={12} md={4}>
          <CalculatorCard 
            title="Systematic Withdrawal Plan"
            description="Systematic Withdrawal Plan (SWP) allows you to withdraw a fixed amount from your mutual fund at regular intervals."
            onClick={handleSWPClick}
          />
        </Grid>

        {/* Lumpsum Calculator Card */}
        <Grid item xs={12} md={4}>
          <CalculatorCard 
            title="Lumpsum"
            description="Lump Sum Calculator helps you determine the future value of a one-time investment based on principal amount, interest rate, and investment duration."
            onClick={handleLumpSumCalculatorClick}
          />
        </Grid>

        {/* Step Up SIP Calculator Card */}
        <Grid item xs={12} md={4}>
          <CalculatorCard 
            title="Step Up SIP "
            description="A Step-Up SIP Calculator estimates the future value of investments by allowing users to gradually increase their SIP amount."
            onClick={handleStepUpSIPCalculatorClick}
          />
        </Grid>

        {/* SIP Goal Calculator Card */}
        <Grid item xs={12} md={4}>
          <CalculatorCard 
            title="SIP Goal"
            description="A SIP Goal Calculator helps you estimate the amount you need to invest regularly to reach your financial goals."
            onClick={handleGoalSIPCalculatorClick}
          />
        </Grid>

        <Grid item xs={false} md={4} />
        
        <Grid item xs={12} md={4}>
          <CalculatorCard
            title="Loan Comparison "
            description="Compare different loan options based on interest rates, tenure, and other factors to help you choose the best loan."
            onClick={handleLoanComparisonCalculatorClick}
          />
        </Grid>

        <Grid item xs={false} md={4} />
        </Grid>
    </Container>
  );
};

export default Dashboard;
